import s from './PictoAndTextList.module.scss'

export interface PictoAndTextListElement {
  picto: JSX.Element
  text: string
}

interface Props {
  list: PictoAndTextListElement[]
}

const PictoAndTextList = ({ list }: Props): JSX.Element => (
  <div className={s.information}>
    <ul>
      {list.map(({ picto, text }, index) => (
        <li key={index}>
          {picto}
          <span>{text}</span>
        </li>
      ))}
    </ul>
  </div>
)

export default PictoAndTextList
